import { formatHtml } from "@trumpf/ux.common-storybook";
import { dummyIcons, IconGridTemplate } from "./icon-grid.templates";

export default {
    title: "Website/Partial Templates/Icon Grid",
    render: IconGridTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const IconGrid = {
    args: {
        items: dummyIcons.slice(0, 4),
    },
};

export const WithLink = {
    args: {
        items: dummyIcons.slice(0, 4).map((item) => ({
            ...item,
            linkUrl: "#",
            linkText: "Mehr erfahren",
        })),
    },
};

export const Triple = {
    args: {
        items: dummyIcons.slice(0, 3).map((item) => ({
            ...item,
            linkUrl: "#",
            linkText: "Mehr erfahren",
        })),
    },
};

export const Quintuple = {
    args: {
        items: dummyIcons.slice(0, 5).map((item) => ({
            ...item,
            linkUrl: "#",
            linkText: "Mehr erfahren",
        })),
    },
};

export const BlueBackground = {
    args: {
        items: WithLink.args.items.map((item) => ({
            ...item,
            teaserColor: "blue",
        })),
        background: "ux-u-background-blue",
    },
};

export const GreyBackground = {
    args: {
        items: WithLink.args.items,
        background: "ux-u-background-grey",
    },
};
